/* ds-live-prices.js - Debug Store, 2026-10-05 (PRICE-1).
   Browser fallback for live prices. The theme snippet ds-prices replaces prices on the server and marks
   those spans data-ds-live="s"; this script refreshes only spans the server could not fill
   (for example beyond Shopify's 20-handle all_products limit).
   Markup: <span data-ds-price="handle1+handle2" data-ds-qty="3" data-ds-prefix="from ">£X</span>.
   The price written in the HTML is the fallback and stays if anything fails.
   2026-10-08 (CODE-1, PRICE-1): when this script fills a span the server marked data-ds-price-missing,
   it removes that marker, so the marker only remains where no live price could be found.
   Log: Z:\claude-projects\Shopify\theme-fixes\2026-10-08 live prices PRICE-1\log.md */
(function () {
  if (window.dsLivePricesLoaded) return;
  window.dsLivePricesLoaded = true;
  function money(pence, cur, lang) {
    var whole = pence % 100 === 0;
    try {
      return new Intl.NumberFormat(lang || 'en-GB', { style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(pence / 100);
    } catch (e) { return null; }
  }
  function run() {
    var els = [].slice.call(document.querySelectorAll('[data-ds-price]:not([data-ds-live])'));
    if (!els.length || !window.fetch) return;
    var data = {};
    els.forEach(function (e) {
      e.getAttribute('data-ds-price').split('+').forEach(function (h) { if (h) data[h] = null; });
    });
    var S = window.Shopify || {};
    var root = (S.routes && S.routes.root) || '/';
    var cur = (S.currency && S.currency.active) || 'GBP';
    var lang = document.documentElement.lang || 'en-GB';
    Promise.all(Object.keys(data).map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=ds-price', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { data[h] = d; })
        .catch(function () {});
    })).then(function () {
      els.forEach(function (e) {
        var sum = 0, ok = true;
        e.getAttribute('data-ds-price').split('+').forEach(function (h) {
          var d = data[h];
          if (!d || typeof d.p !== 'number' || d.c !== cur) ok = false; else sum += d.p;
        });
        if (!ok || sum <= 0) return;
        var q = parseInt(e.getAttribute('data-ds-qty') || '1', 10) || 1;
        var txt = money(sum * q, cur, lang);
        if (!txt) return;
        e.textContent = (e.getAttribute('data-ds-prefix') || '') + txt;
        e.setAttribute('data-ds-live', 'b');
        e.removeAttribute('data-ds-price-missing');
      });
    });
  }
  function later() {
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 200);
  }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();
